module.exports = __webpack_public_path__ + "static/media/arrows-left-down.748f08d4.svg";